import { useDataValue, useDataFormat } from 'Simple/Data'
import { formatTzDate } from 'Data/format.js'
import { startOfMonth, endOfMonth } from 'date-fns'
import { useMemo } from 'react'

export default function useDataConfiguration(props) {
  let location_id = useDataValue({
    context: 'tab',
    viewPath: props.viewPath,
    path: 'selected.location_id',
  })

  let date = useDataValue({
    context: 'sidebar',
    viewPath: props.viewPath,
    path: 'date',
  })

  let time_zone_id = useDataValue({
    context: 'tab',
    path: 'selected.time_zone_id',
    viewPath: props.viewPath,
  })

  let appointment_type_id = useDataValue({
    context: 'tab',
    viewPath: props.viewPath,
    path: 'appointment_overlay.appointment_type_id',
  })

  let appointment_id = useDataFormat({
    context: 'tab',
    viewPath: props.viewPath,
    path: 'appointment_overlay.appointment_id',
    format: value => (value === 'new' ? null : value),
  })

  let patient_id = useDataValue({
    context: 'tab',
    viewPath: props.viewPath,
    path: 'appointment_overlay.patient_id',
  })

  let duration = useDataValue({
    context: 'tab',
    viewPath: props.viewPath,
    path: 'appointment_overlay.duration',
  })

  let { first_day_of_month, last_day_of_month } = useMemo(() => {
    if (!date) return
    return {
      first_day_of_month: startOfMonth(date),
      last_day_of_month: endOfMonth(date),
    }
  }, [date])

  return {
    variables: {
      location_id,
      start_date: formatTzDate(first_day_of_month, 'yyyy-MM-dd', time_zone_id),
      end_date: formatTzDate(last_day_of_month, 'yyyy-MM-dd', time_zone_id),
      appointment_type_id,
      appointment_id,
      duration,
      patient_id,
      include_slots: !!appointment_type_id || !!duration || !!appointment_id,
      include_preferences: !!patient_id,
    },
    pause: !location_id || !first_day_of_month || !last_day_of_month,
    requestPolicy: 'cache-and-network',
  }
}
